import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';
import CartSummaryContainer from '../../checkout/containers/CartSummaryContainer';
import CouponEntryButton from '../../ticket-picker/containers/CouponEntryButton';
import { getCurrentCheckoutStep, isCurrentRouterState } from '../../../selectors/ui';
import { withNavigation } from '@checkout-b/helpers/withNavigation';

class KioskSummaryContainer extends Component {
    render() {

        let isPaymentStep = this.props.currentStep && this.props.currentStep.title && this.props.currentStep.title === "Payment";
        let showCouponButton = !this.props.inCheckout || !isPaymentStep;

        return(
            <div className="kiosk__column">
                <CartSummaryContainer navigate={this.props.navigate}/>
                {showCouponButton && <CouponEntryButton />}
            </div>
        )
    }
}

const mapStateToProps = (state, props) => {
    return {
        currentStep: getCurrentCheckoutStep(state),
        inCheckout: isCurrentRouterState('checkout')(state),
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
    }, dispatch);
}

KioskSummaryContainer.propTypes = {
}

export default connect(mapStateToProps, mapDispatchToProps)(withNavigation(KioskSummaryContainer))
